import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ListButton,
} from 'react-admin'
import { EngineMediaActionDto } from '../../../../core/dto/engine-media/engine-media-action.dto'

const validateEngineMediaActionCreate = (values: EngineMediaActionDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.mediaAction) {
    errors.mediaAction = 'ra.validation.required'
  }
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return (
    <span>{translate('resources.engine-media-actions.titles.create')}</span>
  )
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaActionCreate = (props: CreateProps) => (
  <Create {...props} hasShow={false} title={<CreateTitle />}>
    <SimpleForm
      redirect="list"
      toolbar={<CreateToolbar />}
      validate={validateEngineMediaActionCreate}
    >
      <TextInput source="mediaAction" isRequired />
      <TextInput source="name" isRequired />
    </SimpleForm>
  </Create>
)
